import { render } from "./AboutMain.vue?vue&type=template&id=143d9318&scoped=true"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"

import "./AboutMain.vue?vue&type=style&index=0&id=143d9318&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-143d9318"

export default script